import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userStateAtom } from "../atoms/userStateAtom";
import { useCookies } from "react-cookie";
import SettingModal from "../components/SettingModal";
import axios from "axios";
import { isOpenSettingModal } from "../atoms/isOpenSettingModal";
import { getExperienceData } from "../api/getExperienceData";
import ExperienceBar from "../components/ExperienceBar";
import ActivitiesCalendar from "../components/ActivitiesCalendar";
import Qualification from "../components/Qualification";
import ShowMoney from "../components/ShowMoney";
import Avatar from "boring-avatars";
import CustomedAvatar from "../components/CustomedAvatar";
import AllRanking from "../components/AllRanking";
import WeeklyRanking from "../components/WeeklyRanking";
import MonthlyRanking from "../components/MonthlyRanking";
import AllRoomResultRecord from "../components/AllRoomResultRecord";

interface User {
  id: string;
  accumulatedPoints: string;
}

interface Activity {
  date: string;
  total_activities: string;
}

interface ExperienceData {
  user: string;
  activities: Activity[];
  experience: number;
}

const MyInfo: React.FC = () => {
  const [cookies, , removeCookie] = useCookies(["accessToken"]);
  const [activities, setActivities] = useState<any>([]);
  const [userLoginState, setUserLoginState] = useRecoilState(userStateAtom);
  const userName = userLoginState.userData.name;
  const userId = userLoginState.userData.userIdphp;
  const userGradeNumber = userLoginState.userData.grade;
  const [isModalOpen, setIsModalOpen] = useRecoilState(isOpenSettingModal);
  const [userGrade, setUserGrade] = useState("회원");
  const [userRankingData, setUserRankingData] = useState<User[]>([]);
  const [sortedUserRankingData, setSortedUserRankingData] = useState<User[]>(
    []
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [searchQuery, setSearchQuery] = useState("");
  const [lastActivity, setLastActivity] = useState<Activity | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [experience, setExperience] = useState(0);
  const [fetchedActivities, setFetchedActivities] = useState<any>([]);
  const [money, setMoney] = useState(0);

  const settingModalClick = () => {
    setIsModalOpen(true);
  };

  const maskUserId = (userId: string): string => {
    if (userId.length <= 2) return userId; // If the user ID is 2 characters or less, return it as is
    return userId.slice(0, 2) + "*".repeat(userId.length - 2);
  };

  const getMoney = async () => {
    try {
      const response = await axios.get(
        `https://chamstudyland.com/api/fun_learning/get_money.php?id=${userId}`
      );
      setMoney(response.data);
    } catch (error) {
      console.error("Error fetching money data:", error);
    }
  };

  useEffect(() => {
    getMoney();
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const experienceData = await getExperienceData(userId);
        if (experienceData) {
          const activities = experienceData.activities;
          setFetchedActivities(activities);
          setExperience(experienceData.experience);
          if (activities.length > 0) {
            const lastActivity = activities[activities.length - 1]; // 또는 activities.at(-1);
            setLastActivity(lastActivity);
          } else {
            setLastActivity(null);
          }
        }
      } catch (error) {
        console.error("Error fetching experience data:", error);
      }
    };

    fetchData();
  }, [userId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://chamstudyland.com/api/fun_learning/get_accumulated_point.php"
        );
        setUserRankingData(response.data);
      } catch {
        setError("데이터를 가져오는데 실패했습니다.");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const sortedData = [...userRankingData].sort((a, b) => {
      return parseInt(b.accumulatedPoints) - parseInt(a.accumulatedPoints);
    });
    setSortedUserRankingData(sortedData);
  }, [userRankingData]);

  useEffect(() => {
    switch (userGradeNumber) {
      case "1":
        setUserGrade("예비초");
        break;
      case "2":
        setUserGrade("초1");
        break;
      case "3":
        setUserGrade("초2");
        break;
      case "4":
        setUserGrade("초3");
        break;
      case "5":
        setUserGrade("초4");
        break;
      case "6":
        setUserGrade("초5");
        break;
      case "7":
        setUserGrade("초6");
        break;
      case "8":
        setUserGrade("중1");
        break;
      case "9":
        setUserGrade("중2");
        break;
      case "10":
        setUserGrade("중3");
        break;
      case "11":
        setUserGrade("고1");
        break;
      case "12":
        setUserGrade("고2");
        break;
      case "13":
        setUserGrade("고3");
        break;
      case "14":
        setUserGrade("성인");
        break;
      case "15":
        setUserGrade("관리자");
        break;
      default:
        setUserGrade("회원");
    }
  }, [userGradeNumber]);

  const onLogout = (event: React.MouseEvent<HTMLElement>) => {
    removeCookie("accessToken", { path: "/" });
    setUserLoginState({ isLoggedIn: false, userData: null });
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const filteredData = sortedUserRankingData
    .map((user, index) => ({ ...user, originalRank: index + 1 }))
    .filter((user) => user.id.toLowerCase().includes(searchQuery.toLowerCase()))
    .slice(0, 50);

  const myRankingData = filteredData.filter((user) => user.id === userId);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  console.log("fetched 된 activities", fetchedActivities);

  return (
    <div className="h-fit dark:bg-gray-700 bg-gray-200 pt-12 pb-5">
      <audio autoPlay src="audio/goodresult.mp3">
        오디오다 public 경로는 매핑시 /로 매핑!!!
      </audio>
      <div className="max-w-sm mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
        {isModalOpen && <SettingModal />}
        <div className="border-b px-4 pb-6">
          <div className="flex justify-between p-3">
            <div></div>
          </div>
          <div className="text-center my-4">
            <div className="h-32 w-32 rounded-full border-4 border-white dark:border-gray-800 mx-auto my-4">
              <CustomedAvatar id={userId} />
            </div>

            <div className="py-2">
              <h3 className="font-bold text-2xl text-gray-800 dark:text-white mb-1">
                {userName}
              </h3>
              <div className="inline-flex text-gray-700 dark:text-gray-300 items-center">
                <svg
                  className="h-5 w-5 text-gray-400 dark:text-gray-600 mr-1"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    className=""
                    d="M5.64 16.36a9 9 0 1 1 12.72 0l-5.65 5.66a1 1 0 0 1-1.42 0l-5.65-5.66zm11.31-1.41a7 7 0 1 0-9.9 0L12 19.9l4.95-4.95zM12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                  />
                </svg>
                {userGrade}
              </div>
            </div>
          </div>
          <div className="flex gap-2 px-2">
            <button
              onClick={onLogout}
              className="flex-1 rounded-full bg-blue-600 dark:bg-blue-800 text-white dark:text-white antialiased font-bold hover:bg-blue-800 dark:hover:bg-blue-900 px-4 py-2"
            >
              log out
            </button>
          </div>
        </div>
        <div className="px-4 py-4">
          <div className="flex gap-2 items-center text-gray-800 dark:text-gray-300 mb-4">
            <svg
              className="h-6 w-6 text-gray-600 dark:text-gray-400"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                className=""
                d="M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2z"
              />
            </svg>
            <span>
              최근활동:{" "}
              {lastActivity === null ? "없습니다." : lastActivity.date}
            </span>
          </div>
          <div className="text-gray-800 dark:text-gray-300">
            <div>
              <ExperienceBar experience={experience} />
            </div>
            <div>
              <ShowMoney money={money} />
            </div>
            <div>
              <div className="flex flex-col items-center dark:text-slate-200 text-slate-800 mt-5">
                <button
                  className="bg-pink-300 dark:bg-pink-500 p-3 dark:text-slate-200 rounded-lg hover:ring-2 ring-pink-500 dark:ring-pink-800 shadow-lg font-bold text-slate-700"
                  onClick={settingModalClick}
                >
                  아바타 바꾸기 💰5point
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dark:text-slate-200 font-bold text-slate-800 text-xl max-w-sm mx-auto mt-5">
        나의 랭킹
      </div>
      <table className="max-w-sm mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
        <thead className="bg-gray-50 dark:bg-gray-700">
          <tr>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              랭킹
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              아이디
            </th>
            <th
              scope="col"
              className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
            >
              포인트
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-900">
          {myRankingData.map((user) => (
            <tr>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900 dark:text-gray-200">
                  #{user.originalRank}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-10 w-10">
                    <div className="h-10 w-10 rounded-full">
                      <CustomedAvatar id={user.id} />
                    </div>
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-gray-900 dark:text-gray-200">
                      {user.id}
                    </div>
                    {/* <div className="text-sm text-gray-500 dark:text-gray-400">
                    관리자
                  </div> */}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-200">
                  {user.accumulatedPoints}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="dark:text-slate-200 font-bold text-slate-800 text-xl max-w-sm mx-auto mt-5">
        자격증 및 뱃지
      </div>
      <div className="text-center max-w-sm mx-auto ">
        <div className="w-auto px-6 py-4  ">
          <Qualification userId={userId} />
        </div>
      </div>
      <WeeklyRanking />
      <MonthlyRanking />
      <AllRanking />
      {userGradeNumber === "14" || userGradeNumber === "15" ? (
        <AllRoomResultRecord />
      ) : (
        ""
      )}
      <div className="text-center max-w-sm mx-auto mt-5 mb-7">
        <div className="mt-3 inline-block w-auto text-center min-w-[200px] px-6 py-4 sm:w-auto  ">
          <ActivitiesCalendar activities={fetchedActivities} />
        </div>
      </div>
    </div>
  );
};

export default MyInfo;
